import { PersonalDataDetailsScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <PersonalDataDetailsScreen />;
}
